import {
  SET_INVOICE_DATA,
  SET_INVOICE_COUNT,
  SET_INVOICE_SUMMARY
} from "../types/types";

export const setInvoiceCount = value => {
  return {
    type: SET_INVOICE_COUNT,
    payload: { data: value }
  };
};
export const setInvoiceData = value => {
  return {
    type: SET_INVOICE_DATA,
    payload: { data: value }
  };
};

export const setInvoiceSummary = value => {
  return {
    type: SET_INVOICE_SUMMARY,
    payload: { data: value }
  };
};
